<div>
  <div *ngIf="banners && banners.length > 0" id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
    <div class="carousel-indicators selector-list">
      <button *ngFor="let banner of banners; let i = index"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              [attr.data-bs-slide-to]="i"
              [class.active]="i === currentSlideIndex"
              [attr.aria-current]="i==0"
              [attr.aria-label]="'Slide ' + (i + 1)">
      </button>
    </div>

    <div class="carousel-inner">
      <div class="carousel-container">

        <div *ngFor="let banner of banners; let i = index" class="carousel-item" [class.active]="i === 0">
          <a [href]="banner.link" target="_blank">
            <img class="w-100 slide-img" src="{{ banner?.desktopUrl }}" rel="preload" [alt]="'Slide ' + (i + 1)">
          </a>

          <a [href]="banner.link" target="_blank">
            <img class="w-100 slide-img-mobile" src="{{ banner?.mobileUrl }}" rel="preload" [alt]="'Slide ' + (i + 1)">
          </a>
        </div>

      </div>
    </div>

    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>

  </div>

  <div *ngIf="!banners || banners.length == 0" class="placehoder-banners">

  </div>

<div class="" style="background-color: var(--main-blue);">
  <div class="wrap-max-width d-flex justify-content-center category-icons flex-wrap gap-1">
    <div *ngFor="let category of categories" style="cursor: pointer;">
      <a href="linhas/{{category.slug}}">
        <img loading="lazy" src="{{getIconUrl(category)}}" alt="">
      </a>
    </div>
  </div>
</div>
<div class="text-center bg-yellow-home">
  <div class="wrapper-search-items">
    <input class="input-search-home" (focus)="onFocus()" (blur)="onInputBlur()" (keyup.enter)="onEnter($event)"  (keyup)="onKeyDownEvent($event)" type="text" placeholder="Busca rápida de produtos"/>
    <i tabindex="-1" class="bi bi-search" style="position: absolute; color: var(--main-blue); font-size: 18px; cursor: pointer; top: 35px; right: 20px;"></i>
  </div>
  <div *ngIf="!tutorialEnabled && isInputFocused && !isMobile()" class="tutorial">
    <button tabindex="-1" class="close-tutorial" (click)="toggleTutorial()"> X </button>
    <p>Use a tecla "Tab" para navegar entre os produtos e pressione "Enter" para acessá-los rapidamente.</p>
  </div>
</div>
<div class="">
  <div *ngIf="products && products.length > 0" class=" area-products-news p-2">
    <p class="m-2" style="color: var(--main-blue)">Produtos Encontrados</p>
  </div>
  <div *ngIf="products && products.length < 1 && !inputSearchProductsOff">
    <p class="text-center mt-2" style="color: var(--main-blue)">Nenhum produto encontrado!</p>
  </div>
  <div class="search-area area-products-news" *ngIf="products && products.length">
    <a  *ngFor="let product of products.slice(0, addProducts)" class="d-flex card-grid text-decoration-none" routerLink="/produto-detalhe/{{product.slug ? product.slug : product.codPro }}" [ngClass]="{'show-margin-auto': products.length < 3}" mat-dialog-close >
      <div  *ngIf="product" class="border p-1 d-flex justify-content-center align-itens-center align-self-start search-area card-product-search" >
        <div style="position: absolute;">
          <div *ngIf="product.novo && !product.fora_de_linha" class="circle bg-light-blue"
          style="font-size: 9px !important; width: 50px; height: 50px;"
          >
            NOVO
          </div>
          <div *ngIf="!product.novo && !product.fora_de_linha && product.mais_vendido" class="circle bg-main-yellow best-seller"
          style="width: 50px; height: 50px; gap: 2px"
          >
            <span class="plus" style="font-size: 12px !important;">+</span>
            <span class="seller" style="font-size: 9px !important;">VENDIDO</span>
          </div>
        </div>
        <div style="width: 100%;">
          <img loading="lazy"  [ngClass]="{'opacity-25':product.fora_de_linha}"  style="width: 100%; height: 100%; object-fit: contain;" src="{{product.IMGPR1 ? product.IMGPR1 : 'https://s3.sa-east-1.amazonaws.com/blukitsite.assets/produtos/imagens/imagem-indisponi%CC%81vel.jpg'}}" alt="">
        </div>
      </div>
      <div class="title-search-products-cards" >
        <div class="area-search-title">
          <p class="text-uppercase" style="word-break: break-word"><span class="esconder-prioridade">{{product.prioridade}} - </span>{{product.nome ? product.nome : product.desPro}} </p>
        </div>
        <p class="cod-pro-search" style="line-height: 1.3;">Ref: {{product.codPro}}
          <span *ngIf="product.fora_de_linha" style="color: var(--font-subtitle-gray) !important;" class="text-uppercase">
            <br>
            Indisponível
          </span>
        </p>
      </div>
    </a>
  </div>
  <div *ngIf="products && products.length > 15 && !showedAll" class="d-flex justify-content-center">
    <button class="btn-ver-mais mb-0" (click)="addProductsFiltered()"> VER MAIS RESULTADOS</button>
  </div>
</div>
<div class="d-md-none title p-md-5 p-5 mt-2 text-sm-center" style="line-height: 1.3;">
  Destaques <br><span>Blukit</span>
</div>
<div class="d-none d-md-block title p-md-5 p-2 mt-2 mt-md-3 text-sm-center pt-0">
  Destaques <span>Blukit</span>
</div>

<div class="container-md">
  <div class="area-products-news" *ngIf="destaques && destaques.length > 0">
    <a *ngFor="let release of destaques?.slice(0, qntProducts)" style="text-decoration: none;" class="m-1" routerLink="/produto-detalhe/{{release.slug}}" >
      <div style="position: absolute;">
        <div *ngIf="release.novo" class="circle bg-light-blue">NOVO</div>
        <div *ngIf="!release.novo && !release.fora_de_linha && release.mais_vendido" class="circle bg-main-yellow best-seller">
          <span class="plus">+</span>
          <span class="seller">VENDIDO</span>
        </div>
      </div>
      <div class="border p-3 d-flex justify-content-center align-itens-center align-self-start card-product" >
        <img loading="lazy" *ngIf="release.resizedImageUrl" class="img-card" [src]="release.resizedImageUrl" alt="">
      </div>
      <div class="title-products-cards-home" >
        <p class="mb-1 text-uppercase">{{release.nome ? release.nome : release.desPro}}</p>
        <p class="card-cod-pro-home">Ref: {{release.codPro}}</p>
      </div>
    </a>
  </div>

  <div class="placehoder-area-products" *ngIf="!destaques || destaques.length == 0">
    <div *ngFor="let placehoderCard of placeholderCards" class="placehoder-cards card-product m-1">

    </div>
  </div>
</div>


<div *ngIf="destaques?.length > qntProducts && !showedAll" class="text-center">
  <button class="btn-ver-mais" (click)="addMoreProducts()">VEJA MAIS PRODUTOS</button>
</div>
<div *ngIf="destaques?.length <= qntProducts && showedAll" class="placehoder-see-more">
</div>
<div class="wrap-max-width p-md-5">
  <div class="row" style="box-sizing: border-box;">
    <div class="col-12 col-lg-8 blog p-md-5 p-3 mb-4 mb-lg-0 ">
      <div class="d-flex justify-content-between">
        <div>
          <p class="title p-3 p-lg-4 mt-md-4"><span>BLOG</span></p>
        </div>
        <div>
          <button class="d-none d-md-flex btn-ver-materias p-3 mt-5 text-nowrap" routerLink="/blog">VER OUTRAS MATÉRIAS</button>
        </div>
      </div>
      <div id="grid-posts" class="grid-posts">
        <div class="card-post" *ngFor="let post of listPosts" routerLink="/blog/detalhes/{{post.id}}" style="cursor: pointer;">
          <div class="card-blog">
            <img loading="lazy" class="img-fluid" src="{{post.cover}}" alt="">
          </div>
          <div class="area-card-blog">
            <p class="title-blog-cards" [innerHtml]="post.title.rendered"></p>
            <p class="subtitle-blog-cards" [innerHtml]="post.excerpt.rendered"></p>
          </div>
        </div>

      </div>
      <div class="w-100 d-flex justify-content-center align-items-center" routerLink="/blog">
        <button class="d-md-none d-md-flex btn-ver-materias p-3 mt-5 mb-5 text-nowrap">VER OUTRAS MATÉRIAS</button>
      </div>

    </div>

    <div class="d-none d-lg-block" style="width: 5px;"></div>
    <div class="col-12 col-md-3 flex-fill area-boletim" style="background-color: var(--light-blue); line-height: 1.2;">
      <div class="title p-3 pb-0 p-md-5 pb-md-4 mt-lg-4">
        <span style="color: white !important;">BOLETIM </span><span><br>BLUKIT</span>
      </div>
      <p class="subtitle-boletim">Cadastre-se e
        fique por dentro<br> de nossas novidades:</p>
        <form [formGroup]="formNewsletter">
          <div class="d-flex flex-column p-2 p-md-4 pb-1 pb-md-3">
            <input
            class="input-form"
            type="text" placeholder="Nome"
            formControlName="nome"
            [class.error]="
            formNewsletter.controls['nome'].errors &&
            (formNewsletter.controls['nome'].dirty ||
            formNewsletter.controls['nome'].touched ||
            submitted)"
            >
            <span
            class="text-danger"
            *ngIf="formNewsletter.controls['nome'].errors?.['required'] && (formNewsletter.controls['nome'].dirty || (formNewsletter.controls['nome'].touched) || submitted)"
          >
            Nome é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!formNewsletter.controls['nome'].errors?.['required'] && (formNewsletter.controls['nome'].dirty || (formNewsletter.controls['nome'].touched) || submitted) && formNewsletter.controls['nome'].errors"
          >
            Nome inválido.
          </span>
            <input
            class="input-form"
            type="text" placeholder="E-mail"
            formControlName="email"
            [class.error]="
            formNewsletter.controls['email'].errors &&
            (formNewsletter.controls['email'].dirty ||
            formNewsletter.controls['email'].touched ||
            submitted)"
            >
            <span
            class="text-danger"
            *ngIf="formNewsletter.controls['email'].errors?.['required'] && (formNewsletter.controls['email'].dirty || (formNewsletter.controls['email'].touched)|| submitted)"
          >
            E-mail é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!formNewsletter.controls['email'].errors?.['required'] && (formNewsletter.controls['email'].dirty || (formNewsletter.controls['email'].touched)|| submitted) && formNewsletter.controls['email'].errors"
          >
            E-mail inválido.
          </span>
          </div>
          <div class="text-center mb-5">
            <button class="btn-cadastrar" (click)="registerNewsletter(formNewsletter)" [disabled]="!formNewsletter.valid">CADASTRAR</button>
          </div>
        </form>
    </div>
  </div>
</div>
</div>

